<template>
  <div class="p-6">
    <h2 class="text-3xl font-bold mb-6">📍 Location</h2>

    <button @click="startAdd" class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 mb-4">
      เพิ่มสาขา
    </button>

    <div class="overflow-x-auto border rounded">
      <table class="min-w-full table-auto text-sm">
        <thead class="bg-green-300 text-black">
          <tr>
            <th class="px-4 py-2 text-left">ชื่อสาขา</th>
            <th class="px-4 py-2 text-left">ที่อยู่</th>
            <th class="px-4 py-2">เบอร์โทร</th>
            <th class="px-4 py-2">longitude</th>
            <th class="px-4 py-2">latitude</th>
            <th class="px-4 py-2">รูปภาพ</th>
            <th class="px-4 py-2">Map</th>
            <th class="px-4 py-2">ranking</th>
            <th class="px-4 py-2">action</th>
            <th class="px-4 py-2">Active</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="loc in locations" :key="loc.location_id" class="border-t hover:bg-gray-50 text-center">
            <td class="px-4 py-2 text-left font-semibold">{{ loc.location_name }}</td>
            <td class="px-4 py-2 text-xs text-left">{{ loc.address }}</td>
            <td>{{ loc.phone_number }}</td>
            <td>{{ loc.longitude }}</td>
            <td>{{ loc.latitude }}</td>
            <td>
              <img v-if="loc.image" :src="getImageUrl(loc.image)" class="w-14 h-10 object-cover rounded bg-gray-200" />
              <div v-else class="w-14 h-10 bg-gray-200 rounded inline-block"></div>
            </td>
            <td>
              <a v-if="loc.google_map_url" :href="loc.google_map_url" target="_blank" class="text-blue-600 underline">Map</a>
            </td>
            <td>{{ loc.ranking || '0' }}</td>
            <td>
              <span
                :class="loc.is_active ? 'text-green-600 font-semibold' : 'text-gray-400 italic'"
              >
                {{ loc.is_active ? "Active" : "Inactive" }}
              </span>
            </td>

            <td class="space-x-2 text-xs">
              <button @click="startEdit(loc)" class="text-blue-600 hover:underline">Edit</button>
              <button @click="askDeleteLocation(loc)" class="text-red-600 hover:underline">Remove</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal เพิ่ม/แก้ไข -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="showModal = false">
      <div class="bg-white p-6 rounded-lg w-full max-w-5xl shadow-lg">
        <h2 class="text-3xl font-bold mb-6 text-center">{{ editMode ? 'แก้ไขสาขา' : 'เพิ่มสาขา' }}</h2>

        <div class="grid grid-cols-2 gap-6 text-sm">
          <!-- ฝั่งซ้าย -->
          <div class="space-y-4">
            <div v-for="field in leftFields" :key="field.id">
              <label :for="field.id" class="block mb-1 font-medium text-gray-700">{{ field.label }}</label>
              <input :id="field.id" v-model="form[field.model]" :type="field.type || 'text'" :inputmode="field.type === 'number' ? 'numeric' : null" :pattern="field.type === 'number' ? '[0-9]*' : null" class="w-full border border-gray-300 rounded px-3 py-2" />
            </div>
          </div>

          <!-- ฝั่งขวา -->
          <div class="space-y-4">
            <div v-for="field in rightFields" :key="field.id">
              <label :for="field.id" class="block mb-1 font-medium text-gray-700">{{ field.label }}</label>
              <input :id="field.id" v-model="form[field.model]" type="text" class="w-full border border-gray-300 rounded px-3 py-2" />
            </div>




            <div>
              <label class="block mb-1 font-medium">เวลาเปิด-ปิด</label>
              <select v-model="openType" class="w-full border border-gray-300 rounded px-3 py-2">
                <option value="same">ทุกวัน</option>
                <option value="split">แยกวัน</option>
              </select>
            </div>

            <!-- Same Day Picker -->
            <div v-if="openType === 'same'" class="space-y-2">
              <!-- เปิด -->
              <div class="flex items-center gap-2 relative">
                <span>เปิด:</span>
                <input
                  v-model="openTimeSame.opens"
                  type="time"
                  class="border px-2 py-1 rounded pr-8"
                />
                <button
                  v-if="openTimeSame.opens"
                  @click="openTimeSame.opens = ''"
                  type="button"
                  class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 text-xs"
                >
                  ❌
                </button>
              </div>

              <!-- ปิด -->
              <div class="flex items-center gap-2 relative">
                <span>ปิด:</span>
                <input
                  v-model="openTimeSame.closes"
                  type="time"
                  class="border px-2 py-1 rounded pr-8"
                />
                <button
                  v-if="openTimeSame.closes"
                  @click="openTimeSame.closes = ''"
                  type="button"
                  class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 text-xs"
                >
                  ❌
                </button>
              </div>
            </div>

            <!-- Split Days -->
            <div v-else class="space-y-2">
              <div v-for="day in days" :key="day.key" class="flex items-center gap-2 text-xs">
                <label class="w-20">{{ day.label }}</label>

                <!-- เปิด -->
                <div class="relative w-28">
                  <input
                    v-model="openTimeSplit[day.key].opens"
                    type="time"
                    class="border rounded px-2 py-1 w-full pr-8"
                  />
                  <button
                    v-if="openTimeSplit[day.key].opens"
                    @click="openTimeSplit[day.key].opens = ''"
                    type="button"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 text-xs"
                  >
                    ❌
                  </button>
                </div>

                <span>-</span>

                <!-- ปิด -->
                <div class="relative w-28">
                  <input
                    v-model="openTimeSplit[day.key].closes"
                    type="time"
                    class="border rounded px-2 py-1 w-full pr-8"
                  />
                  <button
                    v-if="openTimeSplit[day.key].closes"
                    @click="openTimeSplit[day.key].closes = ''"
                    type="button"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 text-xs"
                  >
                    ❌
                  </button>
                </div>
              </div>
            </div>

            <div class="flex items-center">
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" v-model="form.is_active" class="sr-only peer">
                <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-green-500 transition duration-200"></div>
                <div
                  class="absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition-transform duration-200 peer-checked:translate-x-full"
                ></div>
              </label>
              <span class="ml-3 text-sm text-gray-700">เปิดใช้งานสาขา</span>
            </div>


          </div>
        </div>

        <div class="mt-6 text-center">
          <button @click="submitForm" class="bg-green-500 text-white px-8 py-2 rounded text-lg hover:bg-green-600">
            {{ editMode ? 'อัปเดต' : 'ยืนยัน' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Confirm Delete -->
    <div v-if="showDeleteConfirm" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-yellow-100 border border-yellow-300 rounded-lg p-6 text-center max-w-sm shadow-md">
        <p class="text-gray-800 text-lg font-semibold mb-4">ลบสาขา "{{ locationToDelete?.location_name }}" ?
        </p>
        <div class="flex justify-center gap-4">
          <button @click="confirmDelete" class="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-6 rounded-full">ใช่</button>
          <button @click="cancelDelete" class="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-full">ไม่ใช่</button>
        </div>
      </div>
    </div>

  </div>
</template>



<script>
import axios from "axios"

export default {
  data() {
    return {
      locations: [],
      showModal: false,
      editMode: false,
      editLocationId: null,
      showDeleteConfirm: false,
      locationToDelete: null,
      openType: "same",
      form: {
        location_name: "", address: "", image: "", phone_number: "",
        latitude: "", longitude: "", google_map_url: "", ranking: "", is_active: true
      },
      hours: Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')),
      minutes: Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')),

      openTimeSame: { opens: '', closes: '' },
      openTimeSplit: {
        monday: { opens: '', closes: '' },
        tuesday: { opens: '', closes: '' },
        wednesday: { opens: '', closes: '' },
        thursday: { opens: '', closes: '' },
        friday: { opens: '', closes: '' },
        saturday: { opens: '', closes: '' },
        sunday: { opens: '', closes: '' },
      },
      leftFields: [
        { label: "ชื่อสาขา", model: "location_name", id: "location_name" },
        { label: "longitude", model: "longitude", id: "longitude" },
        { label: "เบอร์โทร", model: "phone_number", id: "phone", type: "text", inputmode: "numeric", pattern: "[0-9]*" },
        { label: "Map", model: "google_map_url", id: "map" },
        { label: "ranking", model: "ranking", id: "ranking", type: "number" },
      ],
      rightFields: [
        { label: "ที่อยู่", model: "address", id: "address" },
        { label: "รูปภาพ", model: "image", id: "image" },
        { label: "latitude", model: "latitude", id: "latitude" },
      ],
      days: [
        { key: "monday", label: "จันทร์" },
        { key: "tuesday", label: "อังคาร" },
        { key: "wednesday", label: "พุธ" },
        { key: "thursday", label: "พฤหัส" },
        { key: "friday", label: "ศุกร์" },
        { key: "saturday", label: "เสาร์" },
        { key: "sunday", label: "อาทิตย์" },
      ],
    }
  },
  methods: {
    async fetchLocations() {
      try {
        const res = await axios.get("/api/location");
        this.locations = res.data;
      } catch (err) {
        console.error("❌ โหลดสาขาล้มเหลว", err);
      }
    },
    getImageUrl(img) {
      return img?.startsWith("http") ? img : `/images/${img}`;
    },
    startAdd() {
      this.editMode = false;
      this.resetForm();
      this.showModal = true;
    },
    startEdit(loc) {
      this.editMode = true;
      this.showModal = true;
      this.editLocationId = loc.location_id;
      Object.assign(this.form, loc);
      this.form.is_active = !!loc.is_active;

      if (loc.open_time?.startsWith("{")) {
        try {
          const parsed = JSON.parse(loc.open_time);

          if (parsed["ทุกวัน"]) {
            this.openType = "same";
            this.openTimeSame.opens = parsed["ทุกวัน"].opens || "";
            this.openTimeSame.closes = parsed["ทุกวัน"].closes || "";
          } else {
            this.openType = "split";
            Object.keys(parsed).forEach(dayKey => {
              const engKey = this.getEngKeyFromLabel(dayKey);
              if (engKey && this.openTimeSplit[engKey]) {
                this.openTimeSplit[engKey].opens = parsed[dayKey].opens || "";
                this.openTimeSplit[engKey].closes = parsed[dayKey].closes || "";
              }
            });
          }
        } catch {
          console.error("❌ parse open_time failed");
        }
      } else {
        this.openType = "same";
        const [opens, closes] = (loc.open_time || "").split("-");
        this.openTimeSame.opens = opens || "";
        this.openTimeSame.closes = closes || "";
      }
    },
    getEngKeyFromLabel(label) {
      const map = {
        "จันทร์": "monday",
        "อังคาร": "tuesday",
        "พุธ": "wednesday",
        "พฤหัส": "thursday",
        "ศุกร์": "friday",
        "เสาร์": "saturday",
        "อาทิตย์": "sunday",
      };
      return map[label] || label;
    },
    async submitForm() {
      let open_time = "";
      if (this.openType === "same") {
        open_time = JSON.stringify({
          "ทุกวัน": {
            opens: this.openTimeSame.opens,
            closes: this.openTimeSame.closes
          }
        });
      } else {
        const result = {};
        this.days.forEach(({ key, label }) => {
          const time = this.openTimeSplit[key];
          if (time.opens && time.closes) {
            result[label] = {
              opens: time.opens,
              closes: time.closes
            };
          } else {
            result[label] = { opens: "หยุด", closes: "หยุด" };
          }
        });
        open_time = JSON.stringify(result);
      }

      const payload = {
        ...this.form,
        ranking: Number(this.form.ranking),
        open_time
      };

      try {
        if (this.editMode) {
          await axios.put(`/api/location/${this.editLocationId}`, payload);
          alert("✅ อัปเดตสำเร็จ");
        } else {
          await axios.post("/api/location", payload);
          alert("✅ เพิ่มสาขาสำเร็จ");
        }
        this.showModal = false;
        this.fetchLocations();
      } catch (err) {
        console.error("❌ ล้มเหลว:", err.response?.data || err);
        alert("เกิดข้อผิดพลาด");
      }
    },

    async confirmDelete() {
      try {
        await axios.delete(`/api/location/${this.locationToDelete.location_id}`);
        alert("✅ ลบสาขาสำเร็จ");
        this.showDeleteConfirm = false;
        this.locationToDelete = null;
        this.fetchLocations();
      } catch (err) {
        console.error("❌ ลบไม่สำเร็จ:", err);
        alert("เกิดข้อผิดในการลบ");
      }
    },
    resetForm() {
      Object.assign(this.form, {
        location_name: "", address: "", zipcode: "", image: "", phone_number: "",
        latitude: "", longitude: "", google_map_url: "", ranking: "", is_active: true
      });
      this.openTimeSame.opens = "";
      this.openTimeSame.closes = "";
      for (const key in this.openTimeSplit) {
        this.openTimeSplit[key].opens = "";
        this.openTimeSplit[key].closes = "";
      }
      this.openType = "same";
    },
    cancelDelete() {
      this.showDeleteConfirm = false;
      this.locationToDelete = null;
    },
    askDeleteLocation(loc) {
      this.locationToDelete = loc;
      this.showDeleteConfirm = true;
    },
  },
  watch: {},
  mounted() {
    this.fetchLocations();
  }
}
</script>


<style scoped>
.floating-input {
  @apply border border-gray-300 rounded w-full px-3 pt-5 pb-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent;
}
.floating-label {
  @apply absolute left-3 top-2 text-gray-400 text-xs transition-all duration-200 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-500 peer-focus:top-2 peer-focus:text-xs peer-focus:text-green-600;
}
</style>
